import { isLayerWithQuery } from "./layer.js";

export async function LegendTransformation(role, spec, original, specifier, action, option) {
  spec.layer?.forEach((layerItem, li) => {
    if (specifier.layer) {
      let flag = isLayerWithQuery(layerItem, li, specifier.layer.mark, specifier.layer.index, specifier.layer.id);
      if (flag) { // further data query
        if (specifier.data !== undefined) {
          let fstr = toFilterString(specifier.data)
          if (layerItem.transform === undefined) flag = false;
          else {
            if (layerItem.transform.filter(transform => {
              return transform.includes(fstr)
            }).length == 0) flag = false;
          }
        }
      }
      if (!flag) return false;
    }
    layerItem.text?.forEach((textItem) => {
      if (textItem.type === "legend") {
        let flag = true;
        if (specifier.field && textItem.field !== specifier.field) flag = false;
        else if (specifier.aggregate && textItem.aggregate !== specifier.aggregate) flag = false;
        else if (specifier.channel) {
          if (specifier.channel !== textItem.channel) flag = false;
          else if (textItem.field !== layerItem.mark?.[specifier.channel]?.field) flag = false;
        }
        if (flag) {
          if (action === "add") {
            // todo
            if (option.values !== undefined) {
              if (textItem.values !== undefined) {
                textItem.values.splice(textItem.values.length, 0, ...option.values);
                if (textItem.values.every(d => d.constructor.name === "Number" || !isNaN(parseFloat(d)))) {
                  if (textItem.values[0] > textItem.values[1]) {
                    textItem.values = textItem.values.sort((a, b) => { return b - a });
                  } else {
                    textItem.values = textItem.values.sort((a, b) => { return a - b });
                  }
                }
              } else if (option.items !== undefined) {
                let newItems = option.items;
                if (newItems.constructor.name === "Object") newItems = [newItems];
                newItems.forEach(item => {
                  let newItem = {};
                  Object.keys(item).forEach(property => {
                    if (item[property] !== null) {
                      newItem[property] = item[property];
                    }
                  })
                  textItem.items.push(newItem);
                });
              } else {
                let fieldname = textItem.field;
                textItem.values = spec.datatype[fieldname].values;
              }
            }
          } else if (action === "remove") {
            // todo
            if (option?.values !== undefined) {
              if (textItem.values !== undefined) {
                textItem.values = textItem.values.filter(d => !option.values.includes(d))
              } else {
                let fieldname = textItem.field;
                textItem.values = spec.datatype[fieldname].values.filter(d => !option.values.includes(d));
              }
            } else if (option?.items !== undefined) {
              let indexToRemove;
              if (option.items?.index?.constructor.name === "Array") indexToRemove = option.items.index;
              if (option.items?.index?.constructor.name === "Number") indexToRemove = [option.items.index];
              textItem.items?.forEach((elem, ei) => {
                if (indexToRemove.includes(ei)) elem.delete = true;
              })
              textItem.items = textItem.items.filter(_ => !_.delete);
            } else if (specifier.values !== undefined) {
              if (textItem.values !== undefined) {
                textItem.values = textItem.values.filter(d => !specifier.values.includes(d))
              } else {
                let fieldname = textItem.field;
                textItem.values = spec.datatype[fieldname].values.filter(d => !specifier.values.includes(d));
              }
            } else {
              textItem.toDelete = true;
            }
          } else if (action === "replace") {
            if (option.to) {
              if (["hAxis", "vAxis", "axis"].includes(option.to.role)) {
                textItem.type = "on-axis";
                delete textItem["legendX"];
                delete textItem["legendY"];
                delete textItem["direction"];
              }
              Object.keys(option.to).forEach(propertyKey => {
                if (!["role", "field", "mark", "operation", "channel"].includes(propertyKey)) {
                  if (["width", "align", "fontSize", "fontWeight", "lineHeight"].includes(propertyKey)) {
                    textItem.items.forEach((textElem, ti) => {
                      if (option.to[propertyKey]?.constructor.name === "Array") {
                        textElem[propertyKey] = option.to[propertyKey][ti];
                      } else if (option.to[propertyKey] !== null) {
                        textElem[propertyKey] = option.to[propertyKey];
                      } else delete textElem[propertyKey];
                    })
                  } else if (propertyKey === "offset") {
                    if (option.to[propertyKey] !== null) textItem["padding"] = option.to[propertyKey];
                    else textItem["padding"];
                  } else if (propertyKey.startsWith("margin")) {
                    textItem.items.forEach((textElem, ti) => {
                      if (option.to[propertyKey]?.constructor.name === "Array") {
                        textElem[propertyKey] = option.to[propertyKey][ti];
                      } else if (option.to[propertyKey] !== null) {
                        textElem[propertyKey] = option.to[propertyKey];
                      } else delete textElem[propertyKey];
                    })
                  } else {
                    if (option.to[propertyKey] !== null) textItem[propertyKey] = option.to[propertyKey];
                    else textItem[propertyKey];
                  }
                }
              });
            }
          } else if (action === "modify" || action === "reposition") {
            if (option) {
              Object.keys(option)?.forEach(property => {
                if (property === "position") {
                  if (option.position?.constructor.name === "String") {
                    textItem.orient = option.position;
                  } else if (option.position?.constructor.name === "Array" && option.position?.length == 2) {
                    textItem.orient = "none";
                    textItem["legendX"] = option.position[0];
                    textItem["legendY"] = option.position[1];
                  }
                } else if (property === "items") {
                  if (option.items.constructor.name === "Object") {
                    textItem.items.forEach((textElem, ti) => {
                      if (option.items.index !== undefined && ti != option.items.index) return false;
                      else if (option.items.index === undefined || ti == option.items.index) {
                        Object.keys(option.items)?.forEach(property => {
                          if (option.items[property] !== null) {
                            textElem[property] = option.items[property];
                          } else { delete textElem[property]; }
                        })
                      }
                    });
                  } else if (option.items.constructor.name === "Array") {
                    textItem.items.forEach((textElem, ti) => {
                      if (option.items[ti]) {
                        Object.keys(option.items[ti])?.forEach(property => {
                          if (option.items[ti][property] !== null) {
                            textElem[property] = option.items[ti][property];
                          } else { delete textElem[property]; }
                        })
                      }
                    });
                  }
                } else if (property === "title") {
                  if (option[property] === null) {
                    delete textItem.title;
                  } else if (option[property] === true) {
                    textItem.title = { value: textItem.field };
                  } else if (option[property].constructor.name === "Object") {
                    if (textItem.title === undefined) textItem.title = {};
                    Object.keys(option[property]).forEach(subProperty => {
                      let _subProperty = { textAlign: "align", text: "value" }[subProperty] || subProperty;
                      if (option[property][subProperty] === null) delete textItem.title[_subProperty];
                      else textItem.title[_subProperty] = option[property][subProperty];
                    })
                  }
                } else {
                  textItem[property] = option[property];
                }
              });
            }
          }
        }
      }
    });
    if (!layerItem.text) layerItem.text = [];
    layerItem.text = layerItem.text.filter(d => !d.toDelete);
  });
  return spec;
}